import gql from 'graphql-tag';
import apolloClient from '../../apollo/apollo';

const state = {
    departmentStatic: {},
    doctorStatic: {},
    departmentTimes: {},
    doctorTimes: {},
    allDepartmentsBookings: null,
    allDepartmentStats: [],
    allUserStats: [],
    patientAgeStats: [],
    patientGenderStats: [],
    patientInsuranceStats: [],
    patientAdvanceStats: [],
    patientInfoStats: []
};

const getters = {
    // getAllPractitioners: (state) => state.departmentStatic,

};

const mutations = {

    setDepartmentStatic(state, departmentStatic) {
        state.departmentStatic = departmentStatic;
    },

    setDoctorStatic(state, doctorStatic) {
        state.doctorStatic = doctorStatic;
    },

    setDepartmentTimes(state, departmentTimes) {
        state.departmentTimes = departmentTimes;
    },

    setDoctorTimes(state, doctorTimes) {
        state.doctorTimes = doctorTimes;
    },

    setAllDepartmentsBookings(state, allDepartmentsBookings) {
        state.allDepartmentsBookings = allDepartmentsBookings
    },
    setAllDepartmentStats(state, allDepartmentStats) {
        state.allDepartmentStats = allDepartmentStats;
    },
    setAllUserStats(state, allUserStats) {
        state.allUserStats = allUserStats;
    },
    setPatientAgeStats(state, patientAgeStats) {
        state.patientAgeStats = patientAgeStats;
    },
    setPatientGenderStats(state, patientGenderStats) {
        state.patientGenderStats = patientGenderStats;
    },
    setPatientInsuranceStats(state, patientInsuranceStats) {
        state.patientInsuranceStats = patientInsuranceStats;
    },
    setPatientAdvanceStats(state, patientAdvanceStats) {
        state.patientAdvanceStats = patientAdvanceStats;
    },
    setPatientInfoStats(state, patientInfoStats) {
        state.patientInfoStats = patientInfoStats;
    }
};

const actions = {
    async fetchDepartmentStatic({ commit }, payload) {

        try {
            const response = await apolloClient.query({
                query: gql`
                    query {
                        findOneDepartmentById(id: ${payload.departmentId}) {
                            departmentStatic(fromDate: "${payload.fromDate}", toDate: "${payload.toDate}") {
                                totalBookingCancel
                                totalBookingNotCancel
                            }
                        }
                    }
                `,
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });
            commit('setDepartmentStatic', response.data.findOneDepartmentById.departmentStatic);
        } catch (error) {
            console.error("Failed to fetch DepartmentStatic:", error);
        }


    },

    async fetchDoctorStatic({ commit }, payload) {

        try {
            const response = await apolloClient.query({
                query: gql`
                    query findOneDepartmentById($id: Int!, $listOfUserId: [Int], $fromDate: String!, $toDate: String!){
                        findOneDepartmentById(id: $id) {
                            doctorsStatic(fromDate: $fromDate, toDate: $toDate,  listOfUserId: $listOfUserId) {
                                totalBookingCancel
                                totalBookingNotCancel
                                name
                            }
                        }
                    }
                `,
                variables: {
                    id: payload.departmentId,
                    fromDate: payload.fromDate,
                    toDate: payload.toDate,
                    listOfUserId: payload.userId
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });
            commit('setDoctorStatic', response.data.findOneDepartmentById.doctorsStatic);

        } catch (error) {
            console.error("Failed to fetch DoctorStatic:", error);
        }
    },

    async fetchDepartmentTimes({ commit }, payload) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query {
                        findOneDepartmentById(id: ${payload.departmentId}) {
                            departmentStatic(fromDate: "${payload.fromDate}", toDate: "${payload.toDate}") {
                               busyByHour {
                                    count
                                    name
                                }
                            }
                        }
                    }
                `,
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });
            commit('setDepartmentTimes', response.data.findOneDepartmentById.departmentStatic.busyByHour);
        } catch (error) {
            console.error("Failed to fetch DepartmentTimes:", error);
        }
    },

    async fetchDoctorTimes({ commit }, payload) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query findOneDepartmentById($id: Int!, $listOfUserId: [Int], $fromDate: String!, $toDate: String!){
                        findOneDepartmentById(id: $id) {
                            doctorsStatic(fromDate: $fromDate, toDate: $toDate,  listOfUserId: $listOfUserId) {
                                 busyByHour {
                                    count
                                    name
                                }
                            }
                        }
                    }
                `,
                variables: {
                    id: payload.departmentId,
                    fromDate: payload.fromDate,
                    toDate: payload.toDate,
                    listOfUserId: payload.userId
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });

            commit('setDoctorTimes', response.data.findOneDepartmentById.doctorsStatic[0].busyByHour);

        } catch (error) {
            console.error("Failed to fetch DoctorStatic:", error);
        }
    },

    async fetchAllDepartmentsBookings({ commit }, payload) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query {
                        findAllDepartments {
                            departmentStatic(fromDate: "${payload.fromDate}", toDate: "${payload.toDate}") {
                                totalBookingNotCancel
                                name
                            }
                        }
                    }
                `,
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });

            commit('setAllDepartmentsBookings', response.data.findAllDepartments);
        } catch (error) {
            console.error("Failed to fetch AllDepartmentsBookings:", error);
        }
    },

    async fetchAllDepartmentsStats({ commit }, payload) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query allDepartmentsWithPendingAndCanceledBookings($fromDate: String, $toDate: String, $listOfDepartmentId: [Int], $branchId: Int) {
                        allDepartmentsWithPendingAndCanceledBookings(fromDate: $fromDate, toDate: $toDate, listOfDepartmentId: $listOfDepartmentId, branchId: $branchId) {
                            id
                            name
                            pending
                            cancel
                            archive
                            deleted
                            reCreated
                            cancelledArchive
                            cancelledDelete
                            arrive
                            notArrive
                            notSelected
                        }
                    }
                `,
                variables: {
                    fromDate: payload.fromDate,
                    toDate: payload.toDate,
                    listOfDepartmentId: payload.listOfDepartmentId,
                    branchId: payload.branchId || null
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });
            commit('setAllDepartmentStats', response.data.allDepartmentsWithPendingAndCanceledBookings);
        } catch (error) {
            console.error("Failed to fetch AllDepartmentsStats:", error);
        }
    },

    async fetchAllUsersStats({ commit }, payload) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query allUsersWithPendingAndCanceledBookings($fromDate: String, $toDate: String, $listOfUserId: [Int], $listOfDepartmentId: [Int], $branchId: Int) {
                        allUsersWithPendingAndCanceledBookings(fromDate: $fromDate, toDate: $toDate, listOfUserId: $listOfUserId, listOfDepartmentId: $listOfDepartmentId, branchId: $branchId) {
                            id
                            name
                            pending
                            cancel
                            archive
                            deleted
                            reCreated
                            cancelledArchive
                            cancelledDelete
                            arrive
                            notArrive
                            notSelected
                        }
                    }
                `,
                variables: {
                    fromDate: payload.fromDate,
                    toDate: payload.toDate,
                    listOfUserId: payload.listOfUserId,
                    listOfDepartmentId: payload.listOfDepartmentId,
                    branchId: payload.branchId || null
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });
            commit('setAllUserStats', response.data.allUsersWithPendingAndCanceledBookings);
        } catch (error) {
            console.error("Failed to fetch AllUsersStats:", error);
        }
    },

    async fetchPatientAgeStats({ commit }) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query {
                        patientAgeStatics {
                            age
                            total
                        }
                    }
                `,
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });
            commit('setPatientAgeStats', response.data.patientAgeStatics);
        } catch (error) {
            console.error("Failed to fetch PatientAgeStats:", error);
        }
    },

    async fetchPatientGenderStats({ commit }) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query {
                        patientGenderStatics {
                            name
                            total
                        }
                    }
                `,
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });
            commit('setPatientGenderStats', response.data.patientGenderStatics);
        } catch (error) {
            console.error("Failed to fetch PatientGenderStats:", error);
        }
    },

    async fetchPatientInsuranceStats({ commit }) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query {
                        patientInsuranceStatics {
                            name
                            total
                        }
                    }
                `,
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });
            commit('setPatientInsuranceStats', response.data.patientInsuranceStatics);
        } catch (error) {
            console.error("Failed to fetch PatientInsuranceStats:", error);
        }
    },

    async fetchPatientAdvanceStats({ commit }, payload) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query patientAdvanceSearch($input: PatientAdvanceSearchInput) {
                        patientAdvanceSearch(input: $input) {
                            fullName
                            referenceId
                            age
                            insurance
                            totalPendingBooking
                            gender
                            country
                            patientType
                        }
                    }
                `,
                variables: {
                    input: {
                        fromDate: payload.fromDate,
                        toDate: payload.toDate,
                        gender: payload.gender,
                        insurance: payload.insurance,
                        mostPaid: payload.mostPaid,
                        minAge: payload.minAge,
                        maxAge: payload.maxAge,
                        country: payload.country,
                        patientType: payload.patientType,
                        isActive: payload.isActive
                    }
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });
            commit('setPatientAdvanceStats', response.data.patientAdvanceSearch);
        } catch (error) {
            console.error("Failed to fetch PatientAdvanceStats:", error);
        }
    },

    async fetchPatientInfoStats({ commit }, payload) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query patientAdvanceSearch($input: PatientAdvanceSearchInput) {
                        patientAdvanceSearch(input: $input) {
                            fullName
                            referenceId
                            age
                            insurance
                            totalPendingBooking
                            gender
                            country
                            patientType
                        }
                    }
                `,
                variables: {
                    input: {
                        fromDate: payload.fromDate,
                        toDate: payload.toDate,
                        gender: payload.gender,
                        insurance: payload.insurance,
                        mostPaid: payload.mostPaid,
                        minAge: payload.minAge,
                        maxAge: payload.maxAge,
                        country: payload.country,
                        patientType: payload.patientType,
                        isActive: payload.isActive
                    }
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });
            commit('setPatientInfoStats', response.data.patientAdvanceSearch);
        } catch (error) {
            console.error("Failed to fetch PatientInfoStats:", error);
        }
    },


};

export default {
    state,
    getters,
    mutations,
    actions,
};
